import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { EyeOff } from 'lucide-react'
import { PrivacyScreen } from '@/screens/govern/SCR-044-privacy'

const flag = z.preprocess(v => v === true || v === 1 || v === '1' || v === 'true', z.boolean())

export const Route = createFileRoute('/_app/govern/privacy')({
  staticData: { screen: { id: 'SCR-044', title: 'Privacy & forgetting', group: 'Govern', perm: 'privacy.manage', pin: true, order: 1, description: 'Erasure requests, legal holds and what ESM must forget.', icon: EyeOff } },
  validateSearch: z.object({
    tab: z.enum(['cases', 'holds', 'self-service']).optional().catch(undefined),
    state: z.enum(['open', 'closed', 'all']).optional().catch(undefined),
    new: flag.optional().catch(undefined),
    hold: flag.optional().catch(undefined),
  }),
  component: PrivacyScreen,
})
